import { Card, CardBody, Col } from "reactstrap";
import { HorizontalStyleTitle } from "../../../../../../Constants/Constants";
import { HorizontalStyleSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormControls";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CommonCardFooter from "../../../Common/CommonCardFooter";
import HorizontalStyleForm from "./HorizontalStyleForm";

const HorizontalStyle = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-12">
      <Card className="height-equal">
        <CommonCardHeader title={HorizontalStyleTitle} span={HorizontalStyleSubTitle} />
        <CardBody>
          <HorizontalStyleForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="primary" color2="light" />
      </Card>
    </Col>
  );
};
export default HorizontalStyle;
